import { useFormikContext } from 'formik';
import React from 'react';
import { BatchTransaction_batchTransaction } from '../../../__generated__/BatchTransaction';
import { BatchTransactionAvailableDocumentTypes } from '../../../__generated__/BatchTransactionAvailableDocumentTypes';
import { AttachFormModal } from './AttachFormModal';

 interface AttachFormProps {
  availableDocumentTypes: BatchTransactionAvailableDocumentTypes | undefined;
  batchTransaction: BatchTransaction_batchTransaction;
}

export const AttachForm: React.FC<AttachFormProps> = ({
  batchTransaction,
  availableDocumentTypes,
}) => {
  const { dirty } = useFormikContext<any>();

  return (
   
        <AttachFormModal
          batchTransaction={batchTransaction}
          availableDocumentTypes={availableDocumentTypes}
          isDirty={dirty}
        />
   
  );
};
